import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    window.dispatchEvent(new Event("bb-install-ready"));
  });
}

export function InstallButton({ className = "" }) {
  const [ready, setReady] = useState(!!deferred);
  const standalone = typeof window !== "undefined" && window.matchMedia?.("(display-mode: standalone)").matches;
  useEffect(() => {
    const on = () => setReady(true);
    window.addEventListener("bb-install-ready", on);
    return () => window.removeEventListener("bb-install-ready", on);
  }, []);
  if (standalone) return null;
  const install = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      deferred = null;
      setReady(false);
      return;
    }
    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
    toast(ios ? "On iPhone: tap Share, then “Add to Home Screen”." : "Open your browser menu and choose “Install app” or “Add to Home screen”.");
  };
  return (
    <button onClick={install} data-testid="install-app-button"
      className={`inline-flex items-center gap-2 rounded-full border border-[#2A1240]/15 px-4 py-2 text-xs font-semibold text-slate-200 hover:border-[#E0218A] hover:text-[#2A1240] transition-colors ${className}`}>
      <Download className="h-3.5 w-3.5" /> {ready ? "Install app" : "Get the app"}
    </button>
  );
}
